import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/ProjectsAndVessels/Ship/add'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { v3_add_ship } from '../../../actions/v3/projectAndVessel'
const Add = (props) => {

    const onSubmit = async (model) => {
        const res = await v3_add_ship(model);
        if (res.status) {
            toast.success(res.result.message)
            if (!res.result.temporaryCredentials?.length) {
                props.history.push(constant.Authedcomponent.listShipMasterData.url)
            }
        }
        else {
            toast.error(res.error)

        }
        return res;
    }
    return (
        <React.Fragment>
            <Layout
                title={'Vessel'}
            >
                <Form
                    title={'Add Vessel'}
                    onSubmit={onSubmit}
                    onCredentialsAcknowledged={() => props.history.push(constant.Authedcomponent.listShipMasterData.url)}
                    buttonName={'Create Vessel'}
                />
            </Layout>
        </React.Fragment>
    )
}

export default Add
